var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctAnyType, FctCustomArray, FctImage, FctString, FctTupleArray } from '../../../Fct/generics';
import { weiToCurrency } from '../../../Fct/helpers';
export var GetImage = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'getImage',
    name: 'getImage',
    flowType: 'OFFCHAIN_ONLY',
    initParams: {
        depValue: '0',
        valueType: 'number',
    },
    getParams: function () { return ({
        input: {
            initImage: new FctString({ required: false, mode: 'INPUT' }),
            depValue: new FctAnyType({ required: false, mode: 'INPUT' }),
            valueType: new FctString({
                required: false,
                options: [
                    { name: 'number', value: 'number' },
                    { name: 'string', value: 'string' },
                ],
            }),
            'imageconditions_tuple[]': new FctTupleArray({
                params: { condition: new FctCustomArray({}), image: new FctCustomArray({}) },
                description: 'priority goes to the last matched condition',
            }),
            methodParams: {},
        },
        output: {
            image: new FctImage({ required: false, description: 'image' }),
        },
    }); },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, output = _a.output;
        var getImage = function () { return __awaiter(void 0, void 0, void 0, function () {
            var initImage, depValue, valueType, getParamValue, conditionValueType, getAmount, outputImage, value, conditions, images;
            var _a, _b;
            return __generator(this, function (_c) {
                initImage = input.initImage, depValue = input.depValue, valueType = input.valueType;
                getParamValue = function (param) {
                    if (param.isVariable)
                        return param.estimatedValue;
                    return param.value;
                };
                conditionValueType = valueType.value;
                getAmount = function (initValue) {
                    if (!initValue)
                        return initValue;
                    if (conditionValueType !== 'number')
                        return initValue;
                    var decimals = depValue.decimals;
                    if (!decimals)
                        return initValue;
                    return weiToCurrency(initValue, decimals);
                };
                outputImage = getParamValue(initImage);
                value = getAmount(getParamValue(depValue));
                conditions = (_a = input['imageconditions_tuple[]'].params.condition) === null || _a === void 0 ? void 0 : _a.value;
                images = (_b = input['imageconditions_tuple[]'].params.image) === null || _b === void 0 ? void 0 : _b.value;
                output['image'].value = outputImage;
                if (!conditions) {
                    return [2 /*return*/, {
                            params: {},
                            error: undefined,
                        }];
                }
                if (!('length' in conditions)) {
                    return [2 /*return*/, {
                            params: {},
                            error: undefined,
                        }];
                }
                if (!images) {
                    return [2 /*return*/, {
                            params: {},
                            error: undefined,
                        }];
                }
                if (!('length' in images)) {
                    return [2 /*return*/, {
                            params: {},
                            error: undefined,
                        }];
                }
                conditions.forEach(function (condition, index) {
                    if (!condition)
                        return;
                    if (!images[index])
                        return;
                    switch (conditionValueType) {
                        case 'number':
                            try {
                                if (new Function("return ".concat(value, " ").concat(condition))()) {
                                    output.image.value = images[index];
                                }
                            }
                            catch (e) {
                                console.error(e);
                                break;
                            }
                            break;
                        case 'string':
                            if (value === condition) {
                                output.image.value = images[index];
                            }
                            break;
                        default:
                            break;
                    }
                });
                return [2 /*return*/, {
                        params: {},
                        error: undefined,
                    }];
            });
        }); };
        return {
            get: getImage,
            depParamKeys: ['initImage', 'depValue', 'valueType', 'imageconditions_tuple[]'],
        };
    },
});
